import { Component, input, output, inject, computed } from '@angular/core';
import { CommonModalService } from 'src/app/modules/events/services/common-modal.service';
import { TranslationService } from '../service/translation.service';
import { GenericTooltipComponent } from "../components/generic-tooltip/generic-tooltip.component";
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-common-modal',
  templateUrl: './common-modal.component.html',
  styleUrls: ['./common-modal.component.scss'],
  standalone: true,
  imports: [GenericTooltipComponent, CommonModule, TranslateModule],
})
export class CommonModalComponent {

  private readonly commonModalService = inject(CommonModalService)
  private readonly _translationService = inject(TranslationService)

  readonly headerTitle = computed(() => this.commonModalService.modalHeaderTitle());
  readonly isCloseButtonVisible = computed(() => this.commonModalService.modalHeaderIsCloseBtnVisible());
  readonly isSaveButtonVisible = computed(() => this.commonModalService.modalHeaderIsSaveBtnVisible());

  isCloseButtonClicked: boolean = false;
  isSaveButtonClicked: boolean = false;
  showButtonTooltip: boolean = false;

  readonly isCloseModal = input<boolean | undefined>(undefined);
  readonly closeButtonTitle = input<string>('');
  readonly saveButtonTitle = input<string>('');
  readonly showModalContent = input<any>('');
  readonly doneButtonDisabled = input<any>(undefined);
  readonly templateBtn = input<boolean | undefined>(true);
  readonly component = input<string | undefined>(undefined);
  readonly isHeaderVisible = input<boolean | undefined>(undefined);
  readonly closeModalEmitter = output<boolean>();
  readonly saveModalEmitter = output<boolean>();
  readonly type = input<any>(undefined);
  readonly isFooterVisible = input<any>(undefined);
  readonly isCloseBtnVisible = input<boolean>(false);
  readonly showToolTip = input<boolean>(false);
  readonly isInfoSectionAvailable = input<boolean>(false);

  translationData: any;

  close() {
    this.closeModalEmitter.emit(true);
  }

  save() {
    this.saveModalEmitter.emit(true);
  }
}
